
<template>
    <div>
        <template v-if="userPermissions.indexOf('access_social_media_calendar') > -1" class="container-fluid xyz">
            <section class="internal-page-banner-main col-12">
                <div class="container">
                    <div class="row">
                        <div class="page-title">
                            <h1> {{ demo }} </h1>
                        </div>
                    </div>
                </div>
            </section>
            <!--End internal page banner section-->
            <div class="internal-page-main-section contact-page-main col-9 social-media-calendar-container">
                <!--bottom-contact-detail-->
                <div class="container">
                    <div v-show="swipViews == 2">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"> {{formTitle}} <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(2)">Back</button></h2>
                                <div class="">
                                    <form id="socialMediaForm">
                                        <!--Title-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="title">Title<span class="text-danger">*</span></label>
                                                <input v-model="title" type="text" class="form-control" id="title" placeholder="Title">
                                                <font class="text-danger">{{titleError}}</font>
                                            </div>
                                        </div>
                                        <!--Description-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="description">Description<span class="text-danger">*</span></label>
                                                <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" ></tinymce>
                                                <font class="text-danger">{{descriptionError}}</font>
                                            </div>
                                        </div>
                                        <!--Hash Tags-->
                                        <!--div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="hashTag">Hash Tags</label>
                                                <textarea v-model="hashTag" class="form-control" id="hashTag" placeholder="Hash Tags"></textarea>
                                            </div>
                                        </div-->
                                        <!--Attachments-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="dropzone">Attachments</label>
                                                <vue-dropzone
                                                    ref="dropzone"
                                                    id="dropzone"
                                                    :options="dropzoneOptions"
                                                    @vdropzone-success = "uploadDocument"
                                                    @vdropzone-removed-file="removedSelectedFile"
                                                    @vdropzone-error="fileError"
                                                    @vdropzone-file-added="fileAdd"
                                                    :useCustomSlot=true
                                                    >
                                                    <div class="dropzone-custom-content">
                                                        <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                        <div class="subtitle">(Select files from your computer.)</div>
                                                    </div>
                                                </vue-dropzone>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="companies">Companies To Share With<span class="text-danger">*</span></label>
                                                <v-select v-model="companies"
                                                          multiple
                                                          @change="changedValue"
                                                          @input="changedValueCompany()"
                                                          name="companies"
                                                          id="companies"
                                                          label="text"
                                                          :filterable="false"
                                                          :options="companyArr"
                                                          :searchable="false"
                                                          placeholder="Select Company">
                                                </v-select>
                                                <font class="text-danger">{{companyError}}</font>
                                            </div>
                                        </div-->
                                        <!--Date-->
                                        <div class="StartDate col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="startDate" slot="before">Date<span class="text-danger">*</span></label>
                                                <datePicker id="StartDate" v-model="startDateForm" :config="optionsStart" @dp-change="changeStartDt()"></datePicker>
                                                <font class="text-danger">{{startDateError}}</font>
                                            </div>
                                        </div>
                                         <!--TIME-->
                                        <!--<div class="StartDate col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="StartTime" slot="before">Post Time</label>
                                                <datePicker id="StartTime" v-model="startTimeForm" :config="optionsTime"
                                                @dp-change="changeTimeDt()"></datePicker>
                                                <font class="text-danger">{{StartTimeError}}</font>
                                            </div>
                                        </div>-->
                                        <!--Contact Person-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="userId">Contact Person<span class="text-danger">*</span></label>
                                                <input v-model="userId" type="text" class="form-control" id="userId" placeholder="Contact Person">
                                                <font class="text-danger">{{contactPersonError}}</font>
                                            </div>
                                        </div>
                                        <!--Contact Email-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="contactEmail">Contact Email<span class="text-danger">*</span></label>
                                                <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email">
                                                <font class="text-danger">{{contactEmailError}}</font>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Conatct Number-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="contactNumber">Contact Number</label>
                                                <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number">
                                                <font class="text-danger">{{contactNumberError}}</font>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="createdBy">{{createdByTitle}}</label>
                                                <span class="form-control" id="createdBy">{{createdBy}}</span>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Error Alert-->
                                        <div class="row clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <div class="alert alert-danger" id="alertError">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsg" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Buttons-->
                                        <div class="row clearfix"></div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="button-demo">
                                                <input id="CancelSocialMedia" type="submit" value="Cancel" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(2)">
                                                <input id="addSocialMediaBtn" type="submit" value="Save" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="addEvent()">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="swipViews == 1">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"> {{selected.title}}
                                    <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(0)"><i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                                    <template v-if="ergHRId == loginUserID">
                                        <button type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="editEvent(selected.id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                        <button type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="deleteEvents(selected.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                    </template>
                                </h2>
                                <div class="">
                                    <div class=" bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Contact Person </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_person}} </p>
                                                </div>
                                            </div>
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Contact Email </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_email}} </p>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div class="bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Date </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.display_date}} </p>
                                                </div>
                                            </div>
                                            <template v-if="selected.contact_number != ''">
                                                <div class="bus-detail-row width-full float-l">
                                                    <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                        <p class="small-bullet center"></p>
                                                    </div>
                                                    <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                        <p class="color-333333 heading-text-14 line-height-18"> Contact Number </p>
                                                    </div>
                                                    <div class="col-inner-detail col-number colpie-60 float-l">
                                                        <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_number}} </p>
                                                    </div>
                                                </div>
                                            </template>
                                            <!--div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Companies To Share With </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.company_name}} </p>
                                                </div>
                                            </div-->
                                            <!--div class="bus-detail-row width-full float-l ">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Hash Tags </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.has_tags}} </p>
                                                </div>
                                            </div-->
                                        </div>
                                    </div>
                                </div>
                                <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Description </h2>
                                <div class="">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full" v-html='selected.description'></div>
                                    </div>
                                </div>
                                <template v-if="selectedAttachments > 0">
                                    <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Attachments <button type="button" id="DownloadAll" class="btn btn-primary pull-right" v-on:click.prevent="downloadAllAttachments(selected.id)">Download All</button></h2>
                                    <div class="">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full">
                                                <template>
                                                    <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                                        <template v-for="(doc, index1) in selected.attachments">
                                                            <template v-if="doc.type.toLowerCase() == 'image'">
                                                                <swiper-slide>
                                                                    <img :src="doc.url" @click="openGallery(selected.attachments,index1)">
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.type.toLowerCase() == 'video'">
                                                                <swiper-slide>
                                                                    <!--<a :href="doc.url" target="_blank" download><img src="/static/images/video-icon.png" class="link-icon"></a>-->
                                                                    <img v-on:click="downloadImage(doc.url)" src="/static/images/video-icon.png" class="link-icon">
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'doc' || doc.extension.toLowerCase() == 'docx'">
                                                                <swiper-slide>
                                                                    <a :href="doc.url" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'xls' || doc.extension.toLowerCase() == 'xlsx'">
                                                                <swiper-slide>
                                                                    <a :href="doc.url" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'ppt' || doc.extension.toLowerCase() == 'pptx'">
                                                                <swiper-slide>
                                                                    <a :href="doc.url" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'pdf'">
                                                                <swiper-slide>
                                                                    <a :href="doc.url" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else>
                                                                <swiper-slide>
                                                                    <a :href="doc.url" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                                </swiper-slide>
                                                            </template>
                                                        </template>
                                                    </swiper>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-show="swipViews == 0" class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section">
                            <div class="nevCalendar">
                                <button id="" class="btn btn-success pull-left" @click="previousMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                                <button id="" class="btn btn-success pull-left" @click="nextMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                            </div>
                            <button id="refresh" class="btn btn-success pull-right" style="margin-left: 5px; padding: 9px 12px;" @click="refreshEvents"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                            <button id="backToCalendar" class="btn btn-success pull-right" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            <button type="button" id="openModel" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" style="display: none;">Open Modal</button>
                            <!--Search-->
                            <!--<form class="search-form" role="search">-->
                            <div class="btn btn-success form-group pull-right searchBtn" id="search">
                                <input v-model="searchEvents" type="text" class="form-control searchInput" placeholder="Search">
                                <!--<button type="button" class="form-control form-control-submit">Submit</button>-->
                                <span class="search-label"><i class="fa fa-search"></i></span>
                            </div>
                            <!--</form>-->
                            <!--End Search-->

                            <!--Calendar-->
                            <full-calendar id="SMcalendar" :events="events" :config="config" @day-click="dayClick" @event-selected="eventSelected" ref="calendar"></full-calendar>
                            <div class="clearfix"></div>
                            <!--End Calendar-->

                            <!--Event List-->
                            <div id="list" class="list-group">
                                <template v-for="(text, index) in eventList">
                                    <button @click="loadEvent(text.id)" type="button" class="list-group-item list-group-item-action">{{text.title}}<span class="pull-right">{{text.display_date}}</span></button>
                                </template>
                            </div>
                            <!--End Event List-->

                        </div>
                    </div>
                </div>
            </div>
            <template v-if="ergUsersId.length">
              <div class="internal-page-main-section contact-page-main col-3 customer-info-container" style=" margin-top: 150px; padding-top: 0; ">
                    <div style="max-height: 500px; overflow: auto;border:1px solid #666;padding:10px;">
                            <!-- <span style="display:none"> {{ copyEmails=[] }}</span> -->
                            <div class="form-group" v-for="(data,index) in ergUsersId"  >
                                    <div>
                                        <label style=" font-family: 'SanFranciscoDisplayBold' !important; display: block; margin-bottom: 0; ">Member Name: </label>
                                        <span>{{data.first_name}} {{data.last_name}} ({{data.username}})</span>
                                    </div>
                                    <div>
                                        <label style=" font-family: 'SanFranciscoDisplayBold' !important; display: block; margin-bottom: 0; " name="labels" id="copy"> Member Email: </label>
                                        <span>{{data.email}}</span>
                                        <span style="display:none">
                                            <!-- <span>{{copyEmails+=first_name.email}}</span> -->
                                            <!-- <span v-if="index >= 0 && index != ergUsersId.length-1">
                                               {{copyEmails+=","}}
                                            </span> -->
                                                    <!-- && index < ergUsersId[0].length -->
                                        </span>
                                    </div>
                             </div>

                    </div>
                    <button class="btn btn-primary waves-effect pull-right mt-1" @click="doCopy">Copy!</button>
              </div>
            </template>

            <template v-else>
              <div class="internal-page-main-section contact-page-main col-3 customer-info-container" style="
                margin-top: 150px;
                padding-top: 0;

            ">
            <div style="max-height: 500px;
                overflow: auto;border:1px solid #666;padding:10px;" >
                <div class="form-group" >
                <div>

                <label style="
                font-family: 'SanFranciscoDisplayBold' !important;
                display: block;
                margin-bottom: 0;
            " >  Member Not Available</label>


                </div>
                </div>
            </div>
              </div>
            </template>

            <!--bottom-contact-detail-->
            <!-- Modal -->
            <div class="modal fade socialmediacalendarpopup" id="myModal" role="dialog">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-body">
                            <img class="w-100 mb-3" :src="viewImage">
                        </div>
                        <div class="modal-footer">

                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                            <!--<a :href="viewImage" target="_blank" download="" class="ml-2 btn btn-primary pull-right themebutton">download</a>-->
                            <button class="ml-2 btn btn-primary pull-right themebutton" type="button"  v-on:click="downloadImage(viewImage)"><i class="fa fa-download" aria-hidden="true"></i></button>
                            <!--<span class="pull-right pt-10 mr-1">{{lightboxImages.length}} / {{(index+1)}}</span>-->
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <section class="internal-page-banner-main col-12">
                <div class="container">
                    <div class="row">
                        <div class="page-title">
                            <h1> Oops! </h1>
                        </div>
                    </div>
                </div>
            </section>
            <div class="internal-page-main-section contact-page-main col-12">
                <!--bottom-contact-detail-->
                <div class="row">
                    <div class="container">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="row">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"> 403 </h2>
                                <div class="row">
                                    <div class="bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 mb-40 float-l width-full">
                                            Sorry!, You don't have permission to access this page.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>
<style scoped>
.customer-info-container .form-group{
    border-bottom:1px solid #666;
    padding-bottom:10px;
}
.customer-info-container .form-group:last-child{
    border-bottom:0;
    padding-bottom: 0;
    margin-bottom:0;
}
</style>
<script src="vue-clipboard2-master/dist/vue-clipboard.min.js"></script>
<script>
    import Vue from "vue";
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import { Button } from 'bootstrap-vue/es/components';
    import VueSweetalert2 from 'vue-sweetalert2';
    Vue.use(VueSweetalert2);
    import EventBus from './event-bus';
    import moment from 'moment';
    import VueClipboard from 'vue-clipboard2';

    VueClipboard.config.autoSetContainer = true;
    Vue.use(VueClipboard);

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    import tinymce from 'vue-tinymce-editor';

    var self;
    export default {
        name: 'contact',
        components: {
            'v-select': vSelect,
            'full-calendar': FullCalendar,
            'datePicker': datePicker,
            'tinymce': tinymce,
            'vueDropzone': vue2Dropzone,
            swiper,
            swiperSlide,
        },
        mixins: [SessioMixin],
        data() {
            return {
                ergHRId : 0,
                ergUsersId:[],
                copyEmails:[],
                demo:"",
                locationId: 0,
                calendar_title: "",
                detailFromEmailId: 0,
                detailFromEmail: [],
                /* FORM ELEMENTS START*/
                loginUserID: 0,
                error: '',
                editEventID: 0,
                title: '',
                titleError: '',
                description: '',
                descriptionError: '',
                message: '',
                copiedText: '',
                copyEmail:'',
                // hashTag: '',
                //Files
                imagesPaths: [],
                imagesType: [],
                imagesSize: [],
                loadDocArr: [],
                // companies: '',
                // companyArr: [],
                companyError: '',
                startDateForm: new Date(),
                startDateError: '',
                userId: '',
                contactPersonError: '',
                contactEmail: '',
                contactEmailError: '',
                contactNumber: '',
                contactNumberError: '',
                createdByTitle: '',
                createdBy: '',
                optionsStart: {
                    format: 'MM/DD/YYYY HH:mm:ss',
                    /*format: 'MM/DD/YYYY hh:mmA',
                     dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                     minDate: new Date(),
                     minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                     maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),*/
                },optionsTime: {
                    format: 'HH:mm:ss',

                    /*format: 'MM/DD/YYYY hh:mmA',
                     dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                     minDate: new Date(),
                     minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                     maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),*/
                },
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: "POST",
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is too big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    dictRemoveFile: "Remove",
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },
                /* FORM ELEMENTS END*/
                isShowLoggedinfields: true,
                userPermissions: ['access_social_media_calendar'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                swiperOptionAttachments: {
                    slidesPerView: 14.5,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 12.5
                        },
                        1400: {
                            slidesPerView: 11.5
                        },
                        1300: {
                            slidesPerView: 10.4
                        },
                        1200: {
                            slidesPerView: 8.5
                        },
                        1000: {
                            slidesPerView: 7.5
                        },
                        667: {
                            slidesPerView: 5.5
                        },
                        480: {
                            slidesPerView: 3.5
                        },
                        360: {
                            slidesPerView: 3.4
                        }
                    }
                },
                lightboxImages: [],
                viewImage: '',
                index: 0,
                swipViews: 0,
                startDate: 0,
                endData: 0,
                config: {
                    /*'weekends': false,*/
                    defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "Event Calendar Entries Not Available",
                    eventClick: (event) => {
                        this.selected = event;
                        //this.showModel();
                        this.selectedAttachments = this.selected.attachments.length;
                        this.showDetails();
                    },
                    dayClick: (date, jsEvent, view) => {
                        if(this.ergHRId == this.loginUserID){
                            this.swipViews = 2;
                            this.editEventID = 0;
                            this.startDateForm = moment(date).format("MM/DD/YYYY");
                            $("#addSocialMediaBtn").val("Save");
                            this.createdByTitle = 'Created By';
                            this.formTitle = 'Add Event';
                            this.scrollToTop();
                            /*console.log(this.startDateForm);
                            console.log(jsEvent);
                            console.log(view);*/
                        }
                    },
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',
                    }
                },
                events: [],
                selected: {},
                formTitle: "Add Event",
                selectedAttachments: 0,
                eventList: [],
                searchEvents: '',
            }
        },
        watch: {
            description: function (description) {
                /*self.descriptionError = (description.length > 0) ? "" : "Description Required";*/
                if (description.length > 0) {
                    self.descriptionError = "";
                }
            },
            searchEvents: function (searchEvents) {
                self.searchEvent();
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.getBuildVersion();

            var path = window.location.pathname;
            var segments = path.split("/");


            var decodeStr = atob(this.$route.query.data);
            // var url = new URL(webloc+"?"+decodeStr);
            // var copyContractAssId = url.searchParams.get("contractAssetId");

            if (decodeStr != null && decodeStr != "" && (typeof (decodeStr) != "undefined")) {
              self.locationId = decodeStr;
            }

            // self.calendar_title = self.convertToSlug(self.displaytitle);
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
            if (typeof (this.$route.query.id) != "undefined") {
                self.detailFromEmailId = this.$route.query.id;
                self.loadEventDetails();
            }
            self.loadErgSlug();
            self.MenuClose();
            self.getPermissions();
            self.loadCalendarEvents();
            self.formTitle = 'Add Event Calender Entry';
            /*self.searchEvent();*/

//            Hide Initially
            $("#list").hide();
            $("#backToCalendar").hide();

            $("#link").click(function () {
                $('#myModal').modal('toggle');
            });

            $(document).ready(function () {
                $('#search').on("click", (function (e) {
                    $(".searchBtn").addClass("sb-search-open");
                    $("#SMcalendar").hide();
                    $("#refresh").hide();
                    $(".nevCalendar").hide();
                    $("#backToCalendar").show();
                    $("#list").show();
                    e.stopPropagation();
                }));
                $('#backToCalendar').on("click", (function (e) {
                    $(".searchBtn").removeClass("sb-search-open");
                    $("#SMcalendar").show();
                    $("#refresh").show();
                    $(".nevCalendar").show();
                    self.searchEvents = '';
                    $("#backToCalendar").hide();
                    $("#list").hide();
                    e.stopPropagation();
                }));
            });
            /* FORM CODE START*/
            var userObj = localStorage.getItem("user_obj");
            var userJson = [];
            if (userObj != null) {
                userJson = JSON.parse(userObj);
                self.loginUserID = userJson.id;
            } else {
                self.$router.push("/login");
            }
            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            // self.loadCompanies();
            // $("#companies").on('keyup', function () {
            //     self.companyError = '';
            // });
            $("#startDate").on('keyup', function () {
                self.startDateError = '';
            });
            self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
            $("#userId").on('keyup', function () {
                self.contactPersonError = '';
            });
            self.contactEmail = userJson.email;
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            self.contactNumber = userJson.phone;
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            self.createdByTitle = 'Created By';
            $("#alertError").hide();
            /* FORM CODE END*/
        },
        methods: {
          doCopy: function () {
            for (var c = 0 ; c < this.ergUsersId.length; c++) {
                if (c == this.ergUsersId.length - 1) {
                  this.copyEmails += this.ergUsersId[c].email;
                } else {
                  this.copyEmails += this.ergUsersId[c].email + ",";
                }
            }
            this.$copyText(this.copyEmails).then(function (e) {
                Vue.swal('Member\'s Email Copied');
                console.log(e)
            }, function (e) {
                Vue.swal('Member\'s Email canno\'t Copied');
                console.log(e)
            })
          },
          onCopy: function (e) {
              Vue.swal('Member\'s Email Copied');
            },
            onError: function (e) {
              console.log('Failed to copy texts')
            },
            convertToSlug: function(Text)
            {

              // var result = Text.replace( /([A-Z])/g, "$1" );
              // var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                return Text;
            },
            /*FORM CODE START*/
            // loadCompanies(search) {

            //     var config = {
            //         //headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            //         params: {
            //             search: search
            //         }
            //     };
            //     HTTP.get("getcompany", config)
            //             .then(function (response) {
            //                 self.companyArr = [];
            //                 $.each(response.data.content, function (i) {
            //                     /*self.companyArr.push(response.data.content[i].text);*/
            //                     self.companyArr.push(response.data.content[i]);
            //                 });
            //             })
            //             .catch(function (err) {
            //                 if (err.response.status == 0) {
            //                     self.error = "Remote server can not be reachable";
            //                 } else {
            //                     //redirect to login page if user not authenticated
            //                     if (err.response.status == 401) {
            //                         //clear previous data
            //                         localStorage.removeItem("user_obj");
            //                         localStorage.removeItem("api_token");
            //                         localStorage.removeItem("profile_image");
            //                         self.$router.push("/login");
            //                         //EventBus.$emit("logged-in", true, "", "");
            //                     }
            //                     self.error = err.response.data.message;
            //                 }
            //             });
            // },
            checkForm: function () {
                var checked = true;
                self.titleError = "";
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.title.length > 190) {
                    self.titleError = "Title cannot be longer than 190 character";
                    if (checked) {
                        checked = false;
                    }
                }
                self.descriptionError = "";
                if (!self.description) {
                    self.descriptionError = "Description Required";
                    if (checked) {
                        checked = false;
                    }
                }
                // self.companyError = "";
                // if (self.companies.length === 0) {
                //     self.companyError = "Company Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                self.startDateError = "";
                if (!self.startDateForm) {
                    self.startDateError = "Date Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.contactPersonError = "";
                if (!self.userId) {
                    self.contactPersonError = 'Please Enter Contact Person';
                    if (checked) {
                        checked = false;
                    }
                }
                self.contactEmailError = "";
                if (!self.contactEmail) {
                    self.contactEmailError = 'Please Enter Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.contactEmail && !self.validEmail(self.contactEmail)) {
                    self.contactEmailError = 'Please Enter Valid Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                self.contactNumberError = "";
                if (self.contactNumber && !String(self.contactNumber).match(/^[0-9]*$/)) {
                    self.contactNumberError = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length < 10) {
                    self.contactNumberError = "Phone Number Must Be Of Minimum 10 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length > 13) {
                    self.contactNumberError = "Phone Number Must Be Of Maximum 13 Digits";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            uploadDocument: function (file, response) {
                var self = this;
                //console.log(file);
                /* self.isFileUploaded = true; */
                self.imagesPaths.push(response.content);
                //console.log(self.imagesPaths);

                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                this.$refs.dropzone.setOption('maxFiles', null);
            },
            removedSelectedFile: function (file, xhr, error) {
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
                this.$refs.dropzone.setOption('maxFiles', null);
                var self = this;
                var removeFile = "";
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* if (self.imagesPaths.length <= 0) {
                 self.isFileUploaded = false;
                 } */
                if ("manuallyAdded" in file == true) {
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.imagesPaths[i];
                        }
                    }
                    this.$refs.dropzone.setOption('maxFiles', null);
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === removeFile) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        //break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }
                this.$refs.dropzone.setOption('maxFiles', null);
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
            },
            removeFileFromServer: function (filePath) {
                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */
            },
            fileAdd: function (file, xhr, error) {
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* console.log("File Add"); */
            },
            uploadManually: function (file) {

                var self = this;
                for (var i = 0; i < self.loadDocArr.length; i++) {

                    var url = self.loadDocArr[i]['url'];
                    var file_name = self.getFileName(self.loadDocArr[i]['url']);
                    var file_type = self.loadDocArr[i]['file_type'];
                    var file_size = self.loadDocArr[i]['size'];

                    self.imagesType.push(file_type);
                    self.imagesSize.push(Number(file_size));

                    var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                }
                /* console.log("Accepted");
                 console.log(this.$refs.dropzone.getAcceptedFiles());
                 console.log("Rejected");
                 console.log(this.$refs.dropzone.getRejectedFiles()); */

                //this.$refs.dropzone.addRemoveLinks = true;

            },
            getFileType: function (file_name) {

                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]

                self.imagesPaths.push(String(orgPath + "/" + file_name));

                return file_name;
            },
            removeAllFiles: function () {
                this.$refs.dropzone.removeAllFiles();
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedValueCompany: function () {
                self.companyError = "";
            },
            changeStartDt: function () {
                self.startDateError = "";
            },
            addEvent() {
                if (self.checkForm()) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    // var companiesId = '';
                    // for (var i = 0; i < self.companies.length; i++) {
                    //     companiesId += (self.companies[i].value) + ',';
                    // }
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    // companiesId = companiesId.replace(/,\s*$/, "");
                    var start_date = self.startDateForm;
                    if (self.editEventID == 0) {
                        var data = {
                            title: self.title,
                            imagePath: self.imagesPaths,
                            userss:self.ergUsersId,
                            imageSize: self.imagesSize,
                            imageType: self.imagesType,
                            // companies_id: companiesId,
                            description: self.description,
                            // hashtag: self.hashTag,
                            startDate: start_date,
                            contactPerson: self.userId,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            slug_url:segments[2],
                            erg_calendar:true,
                            slug: segments[2] + self.locationId,
                        };
                        $("#addSocialMediaBtn").val("Saving ...");
                    } else {
                        var data = {
                            title: self.title,
                            imagePath: self.imagesPaths,
                            userss:self.ergUsersId,
                            imageSize: self.imagesSize,
                            imageType: self.imagesType,
                            // companies_id: companiesId,
                            description: self.description,
                            // hashtag: self.hashTag,
                            startDate: start_date,
                            contactPerson: self.userId,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            id: self.editEventID,
                            slug_url:segments[2],
                            erg_calendar:true,
                            slug: segments[2] + self.locationId
                        };
                        $("#addSocialMediaBtn").val("Updating ...");
                    }
                    $("#addSocialMediaBtn").prop("disabled", true);
                    $("#CancelSocialMedia").prop("disabled", true);
                    HTTP.post("addupdatesocialmedia", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (self.editEventID == 0) {
                                    $("#addSocialMediaBtn").val("Save");
                                } else {
                                    $("#addSocialMediaBtn").val("Update");
                                }
                                $("#addSocialMediaBtn").prop("disabled", false);
                                $("#CancelSocialMedia").prop("disabled", false);
                                if (response.data.message == "success") {
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    self.title = '';
                                    // self.companies = '';
                                    self.description = '';
                                    // self.hashTag = '';
                                    self.startDateForm = new Date();
                                    self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                                    self.contactEmail = userJson.email;
                                    self.contactNumber = userJson.phone;
                                    self.userArr = [];
                                    self.imagesPaths = [];
                                    self.imagesSize = [];
                                    self.imagesType = [];
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.buttonBack(2);
                                    }, 3000);
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.buttonBack(2);
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (self.editEventID == 0) {
                                    $("#addSocialMediaBtn").val("Save");
                                } else {
                                    $("#addSocialMediaBtn").val("Update");
                                }
                                $("#addSocialMediaBtn").prop("disabled", false);
                                $("#CancelSocialMedia").prop("disabled", false);
                                $("#errorMsg").html(err.response.data.message);
                                $(".alert-danger").removeClass("hide");
                                $(".alert-danger").addClass("show");
                                setTimeout(function () {
                                    $(".alert-danger").removeClass("show");
                                    $(".alert-danger").addClass("hide");
                                }, 5000);
                                if (err.response.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                            });

                }
            },
            editEvent(eventID) {
                self.editEventID = eventID;
                /*self.createdByTitle = 'Last Updated By';*/
                self.createdByTitle = 'Updated By';
                self.formTitle = 'Edit Event Entry';
                self.loadEventEdit();
                $("#addSocialMediaBtn").val("Update");
                self.scrollToTop();
            },
            loadEventEdit() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: self.editEventID,
                    }
                };
                HTTP.get("getsocialentry", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.title = response.data.content.title;
                                self.description = response.data.content.description;
                                // self.hashTag = response.data.content.has_tags;
                                self.userId = response.data.content.contact_person;
                                self.contactEmail = response.data.content.contact_email;
                                self.contactNumber = response.data.content.contact_number;
                                self.createdBy = response.data.content.last_updated_by;
                                var userJson = [];
                                var userObj = localStorage.getItem("user_obj");
                                if (userObj != null) {
                                    userJson = JSON.parse(userObj);
                                } else {
                                    self.$router.push("/login");
                                }
                                self.createdBy = userJson.first_name + " " + userJson.last_name;
                                self.loadDocArr = response.data.content.attachments;
                                self.uploadManually();
                                // self.companies = [];
                                // for (var i = 0; i < response.data.content.selected_company.length; i++) {
                                //     self.companies.push({'text': response.data.content.selected_company[i].name, 'value': response.data.content.selected_company[i].id});
                                // }
                                setTimeout(function () {
                                    self.startDateForm = moment(response.data.content.start_date_time).format("MM/DD/YYYY HH:mm");
                                    /*console.log(moment(response.data.content.start_date_time).format("MM/DD/YYYY HH-mm-ss"));
                                     console.log(moment.utc(response.data.content.start_date_time).format("MM/DD/YYYY HH-mm-ss"));*/
                                }, 200);
                            } else {
                                self.$swal('Cancelled', response.data.message, 'info');
                                self.buttonBack(2);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                } else {
                                    self.$swal('Cancelled', err.response.data.message, 'info');
                                    self.buttonBack(2);
                                }
                                self.error = err.response.data.message;
                            }
                        });
                self.swipViews = 2;
            },
            loadEventDetails() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: self.detailFromEmailId,
                    }
                };
                HTTP.get("getsocialentry", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.config.defaultDate = moment(response.data.content.start_date_time).format("YYYY-MM-DD hh:mm");
                                self.$refs.calendar.fireMethod('gotoDate', self.config.defaultDate);
                                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                                self.loadCalendarEvents();
                            } else {
                                self.$swal('Cancelled', response.data.message, 'info');
                                self.buttonBack(2);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                } else {
                                    self.$swal('Cancelled', err.response.data.message, 'info');
                                    self.buttonBack(2);
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            buttonBack(viewID) {
                self.swipViews = 0;
                self.scrollToTop();
                if (viewID == 2) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    self.editEventID = 0;
                    self.removeAllFiles();
                    self.title = '';
                    // self.companies = '';
                    self.description = '';
                    // self.hashTag = '';
                    self.startDateForm = new Date();
                    self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                    self.contactEmail = userJson.email;
                    self.contactNumber = userJson.phone;
                    self.userArr = [];
                    self.imagesPaths = [];
                    self.imagesSize = [];
                    self.imagesType = [];
                    self.loadCalendarEvents();
                }
            },
            deleteEvents: function (id) {
                var eventArr = [];
                eventArr.push(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        deleteArr: eventArr,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deleteSocialEvents", config)
                                .then(function (response) {
                                    self.buttonBack(2);
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        } else {
                                            self.$swal('Cancelled', err.response.data.message, 'info');
                                            self.buttonBack(2);
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record still intact', 'info')
                    }
                })
            },
            scrollToTop() {
                $('#scroll').click();
                /*$("html, body").animate({
                 scrollTop: 0
                 }, 600);
                 return true;*/
            },
            /*FORM CODE END*/
            previousMonth() {
                self.$refs.calendar.fireMethod('prev');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            nextMonth() {
                self.$refs.calendar.fireMethod('next');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            openGallery: function (documents, index) {
                var self = this;
                var arr = [];
                var new_index = 0;
                $.each(documents, function (i) {
                    if (documents[i].type.toLowerCase() == 'image') {
                        if (i == index) {
                            index = new_index;
                        }
                        arr.push(documents[i].url);
                        new_index = new_index + 1;
                    }
                });
                self.loadImagesInLightBox(arr, index);
            },
            loadImagesInLightBox: function (arr, index) {
                self.lightboxImages = arr;
                self.index = index;
                self.viewImage = self.lightboxImages[self.index];
                /*console.log(self.lightboxImages);
                 console.log(self.index);
                 console.log(self.viewImage);*/
                $('#openModel').click();
            },
            changeImage: function (move) {
                var self = this;
                if (move == 'next') {
                    self.index = self.index + 1;
                    if (self.lightboxImages.length <= self.index) {
                        self.index = 0;
                    }
                } else {
                    self.index = self.index - 1;
                    if (self.index < 0) {
                        self.index = (self.lightboxImages.length - 1);
                    }
                }
                self.viewImage = self.lightboxImages[self.index];
            },
            downloadImage: function (filepath) {
                //console.log(filepath);
                window.open(filepath, 'Download');
                //window.location.assign(self.viewImage);
                /*location.href = self.viewImage;*/
            },
            loadEvent(id) {
                $.each(self.eventList, function (i) {
                    if (self.eventList[i].id == id) {
                        self.selected = self.eventList[i];
                    }
                });
                self.showDetails();
            },
            searchEvent() {
                if (self.searchEvents.length >= 1) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {search: self.searchEvents}
                    };
                    HTTP.get("getsocialmediacalendar", config)
                            .then(function (response) {
                                self.eventList = response.data.content;
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                }
            },
            refreshEvents() {
                var refresh = true;
                if (refresh) {
                    self.loadCalendarEvents();
                }
            },
            showDetails() {
                /*console.log(self.selected);
                 console.log(self.selected.title);*/
                self.swipViews = 1;
                self.scrollToTop();
            },
            showModel() {
                //console.log(self.selected.id);
                $('#openModel').click();
            },
            eventSelected(event) {
                self.selected = event;
                //console.log(self.selected);
            },
            dayClick(date, jsEvent, view) {
                /*console.log(date);
                 console.log(jsEvent);
                 console.log(view);*/
            },
            loadCalendarEvents() {
                var path = window.location.pathname;
                var segments = path.split("/");
                self.selected = {};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        start_date: self.startDate,
                        end_date: self.endDate,
                        id: self.detailFromEmailId,
                        slug: segments[2]+ self.locationId,
                    }
                };
                HTTP.get("getergcalendar", config)
                        .then(function (response) {
                            self.events = response.data.content;
                            self.$refs.calendar.$emit('refetch-events');
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadErgSlug() {
                var path = window.location.pathname;
                var segments = path.split("/");
                self.selected = {};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        slug: segments[2],
                    }
                };
                HTTP.get("getergslug", config)
                        .then(function (response) {
                            self.ergHRId = response.data.content.hr_id;
                            self.ergUsersId=response.data.content.users_id;
                            self.demo=response.data.content.title;
                            /* self.events = response.data.content;
                            self.$refs.calendar.$emit('refetch-events'); */
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            downloadAllAttachments(id) {
                /*console.log(id);*/
                $("#DownloadAll").prop("disabled", true);
                $("#DownloadAll").html("Preparing File...");
                if (id) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {id: id}
                    };
                    HTTP.get("downloadattachment", config)
                            .then(function (response) {
                                /*console.log(id);*/
                                self.downloadImage(response.data.content.zip_file);
                                $("#DownloadAll").prop("disabled", false);
                                $("#DownloadAll").html("Download All");
                            })
                            .catch(function (err) {
                                $("#DownloadAll").prop("disabled", false);
                                $("#DownloadAll").html("Download All");
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    } else {
                                        self.$swal('Cancelled', err.response.data.message, 'info');
                                        self.buttonBack(2);
                                    }
                                }
                            });
                }
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/ERGCalendar.vue